import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="wave-transition"]' ).forEach( ( section ) => {
        const waves = section.querySelector( '.waves' );
        if ( ! waves ) return;

        gsap.to( waves, {
          '--wave-x': '168px',
          'scrollTrigger': {
            trigger: section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'wave-transition', COMPONENT );
} )( app );
